// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2282684a","732":"87c22897","977":"58e33334"}[chunkId] + ".chunk.js";
};